import { useMutation } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import {
  InvocationStatusEnum,
  type AgentInvocationRequest,
} from "../../generated/core-api";

export const TERMINAL_INVOCATION_STATUSES: string[] = [
  InvocationStatusEnum.COMPLETED,
  InvocationStatusEnum.FAILED,
  InvocationStatusEnum.TERMINATED,
];

export function isTerminalInvocationStatus(
  status: string | null | undefined,
): boolean {
  return !!status && TERMINAL_INVOCATION_STATUSES.includes(status);
}

export function useAgentInvocationPoll(
  agentId: string | null | undefined,
  workflowId: string | null | undefined,
) {
  return useQuery({
    queryKey: ["agentInvocation", agentId, workflowId],
    queryFn: () => api.getInvocationStatus(agentId as string, workflowId as string),
    enabled: !!agentId && !!workflowId,
    refetchInterval: (query) =>
      isTerminalInvocationStatus(query.state.data?.status) ? false : 2000,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}

export type AgentRuntimeInvocationInput = AgentInvocationRequest;

export function useInvokeAgent(agentId: string) {
  return useMutation({
    mutationFn: (request: AgentInvocationRequest) =>
      api.invokeAgent(agentId, request),
  });
}
